import { T } from "../constants/theme";

const WIDTH = 320;
const HEIGHT = 96;
const PAD = 8;

export default function TelemetrySparkline({ points, color = T.gold, unit = "" }) {
  if (!points || points.length === 0) {
    return (
      <div style={{ fontSize: 12, color: "#999", padding: "12px 0" }}>
        No readings yet
      </div>
    );
  }

  const values = points.map((p) => p.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;

  const coords = points.map((p, i) => {
    const x = points.length === 1 ? WIDTH / 2 : PAD + (i / (points.length - 1)) * (WIDTH - PAD * 2);
    const y = HEIGHT - PAD - ((p.value - min) / range) * (HEIGHT - PAD * 2);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });

  const latest = points[points.length - 1];

  return (
    <div>
      <svg
        width="100%"
        height={HEIGHT}
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        preserveAspectRatio="none"
        style={{ display: "block" }}
      >
        <polyline
          points={coords.join(" ")}
          fill="none"
          stroke={color}
          strokeWidth={2}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
      <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
        Latest: <strong>{latest.value}{unit}</strong>{" "}
        <span style={{ color: "#999" }}>
          ({new Date(latest.recorded_at).toLocaleTimeString()})
        </span>
      </div>
    </div>
  );
}
